@if (hasDate) {
  <span>
    @if (start) {
      <span [textContent]="start"></span>
    } @else {
      <i class="fa fa-question fa-xs"></i>
    }
    <span class="text-muted"> - </span>
    @if (end) {
      <span [textContent]="end"></span>
    } @else {
      <i class="fa fa-question fa-xs"></i>
    }
  </span>
} @else {
  <span class="text-muted">
    <i class="fa fa-times text-muted"></i>
  </span>
}


